export const DuplicateEventsRemove = (allEvents) => {
    const uniqueEvents = [];
    const ids = new Set();

    allEvents.forEach(item => {
        if (!ids.has(item.id)) {
            ids.add(item.id);
            uniqueEvents.push(item);
        }
    });

    return uniqueEvents;
}